export enum ProductType {
  SALE = 0,
  PURCHASE
}
